module.exports = __webpack_public_path__ + "static/img/logo_lc.6cf8105.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_lc.png
// module id = Z1Yj
// module chunks = 16